<div *ngIf="showAlert" class="alert" [ngClass]="alertClass" style="padding-bottom:20px">
  <b>{{message}}</b>
  <button type="button" class="close btn btn-primary" style="float:right;margin-top:-7px" (click)="showAlert = false;">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
